export default __webpack_public_path__ + "static/media/Freight Transport.776511f1.pdf";